import React, { useMemo } from 'react';
import AssistantChat from './AssistantChat';
import { financialAnalystChatConfig } from './assistantChatConfigs';

function FinancialAnalystChat(props: { agent: string; data: any }) {
  const config = useMemo(
    () => financialAnalystChatConfig(props),
    [props.agent, props.data]
  );
  return <AssistantChat config={config} />;
}

export default FinancialAnalystChat;
